export default {
    "name": "CustomerSalesOrders",
    "kind": "HoudiniQuery",
    "hash": "e4a6c8485f9c33ad20e7b55180c7859533a08ea6ffe4f3176a3fc4d82d1d1a0e",

    "raw": `query CustomerSalesOrders($customerId: UInt!, $filter: SalesOrderFilter, $pagination: PaginationOptions, $linePagination: PaginationOptions) {
  customer(id: $customerId) {
    salesOrders(filter: $filter, pagination: $pagination) {
      items {
        salesOrderId
        adjustmentTotal
        adjustments {
          adjustmentType {
            id
            name
            code
            showOnSalesOrders
          }
          amount
          date
          id
        }
        appliedPaymentLines {
          amount
          id
          payment {
            comments
            date
            documentNumber
            id
            storeId
            paymentMethod {
              id
              name
            }
          }
        }
        balance
        counterperson {
          id
          name
        }
        date
        documentType {
          id
          name
        }
        finalized
        id
        lines(pagination: $linePagination) {
          items {
            description
            id
            inventory {
              vehicle {
                stockNumber
                id
              }
              defaultVendor {
                id
                code
              }
              id
            }
            lookup
            price
            quantity
            total
          }
        }
        paid
        purchaseOrderNumber
        salesperson {
          id
          name
        }
        shippingAddress {
          company
        }
        store {
          id
        }
        subtotal
        tax
        total
        void
      }
      pageInfo {
        pageNumber
        pageSize
        totalPages
      }
      totalItems
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "customer": {
                "type": "Customer",
                "keyRaw": "customer(id: $customerId)",

                "selection": {
                    "fields": {
                        "salesOrders": {
                            "type": "SalesOrderList",
                            "keyRaw": "salesOrders(filter: $filter, pagination: $pagination)",

                            "selection": {
                                "fields": {
                                    "items": {
                                        "type": "SalesOrder",
                                        "keyRaw": "items",

                                        "selection": {
                                            "fields": {
                                                "salesOrderId": {
                                                    "type": "UInt",
                                                    "keyRaw": "salesOrderId",
                                                    "visible": true
                                                },

                                                "adjustmentTotal": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "adjustmentTotal",
                                                    "visible": true
                                                },

                                                "adjustments": {
                                                    "type": "SalesOrderAdjustment",
                                                    "keyRaw": "adjustments",

                                                    "selection": {
                                                        "fields": {
                                                            "adjustmentType": {
                                                                "type": "AdjustmentType",
                                                                "keyRaw": "adjustmentType",

                                                                "selection": {
                                                                    "fields": {
                                                                        "id": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        },

                                                                        "name": {
                                                                            "type": "String",
                                                                            "keyRaw": "name",
                                                                            "visible": true
                                                                        },

                                                                        "code": {
                                                                            "type": "String",
                                                                            "keyRaw": "code",
                                                                            "visible": true
                                                                        },

                                                                        "showOnSalesOrders": {
                                                                            "type": "Boolean",
                                                                            "keyRaw": "showOnSalesOrders",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "amount": {
                                                                "type": "Decimal2",
                                                                "keyRaw": "amount",
                                                                "visible": true
                                                            },

                                                            "date": {
                                                                "type": "Date",
                                                                "keyRaw": "date",
                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "appliedPaymentLines": {
                                                    "type": "PaymentLine",
                                                    "keyRaw": "appliedPaymentLines",

                                                    "selection": {
                                                        "fields": {
                                                            "amount": {
                                                                "type": "Decimal2",
                                                                "keyRaw": "amount",
                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "payment": {
                                                                "type": "Payment",
                                                                "keyRaw": "payment",

                                                                "selection": {
                                                                    "fields": {
                                                                        "comments": {
                                                                            "type": "String",
                                                                            "keyRaw": "comments",
                                                                            "visible": true
                                                                        },

                                                                        "date": {
                                                                            "type": "Date",
                                                                            "keyRaw": "date",
                                                                            "visible": true
                                                                        },

                                                                        "documentNumber": {
                                                                            "type": "String",
                                                                            "keyRaw": "documentNumber",
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        },

                                                                        "storeId": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "storeId",
                                                                            "visible": true
                                                                        },

                                                                        "paymentMethod": {
                                                                            "type": "PaymentMethod",
                                                                            "keyRaw": "paymentMethod",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "id": {
                                                                                        "type": "UInt",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    },

                                                                                    "name": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "name",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "balance": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "balance",
                                                    "visible": true
                                                },

                                                "counterperson": {
                                                    "type": "UserAccount",
                                                    "keyRaw": "counterperson",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "Int",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "date": {
                                                    "type": "Date",
                                                    "keyRaw": "date",
                                                    "visible": true
                                                },

                                                "documentType": {
                                                    "type": "SalesOrderDocument",
                                                    "keyRaw": "documentType",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "finalized": {
                                                    "type": "Boolean",
                                                    "keyRaw": "finalized",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "ID",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "lines": {
                                                    "type": "SalesOrderLineList",
                                                    "keyRaw": "lines(pagination: $linePagination)",

                                                    "selection": {
                                                        "fields": {
                                                            "items": {
                                                                "type": "SalesOrderLine",
                                                                "keyRaw": "items",

                                                                "selection": {
                                                                    "fields": {
                                                                        "description": {
                                                                            "type": "String",
                                                                            "keyRaw": "description",
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        },

                                                                        "inventory": {
                                                                            "type": "Inventory",
                                                                            "keyRaw": "inventory",
                                                                            "nullable": true,

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "vehicle": {
                                                                                        "type": "Vehicle",
                                                                                        "keyRaw": "vehicle",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "stockNumber": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "stockNumber",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "id": {
                                                                                                    "type": "UInt",
                                                                                                    "keyRaw": "id",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "defaultVendor": {
                                                                                        "type": "Vendor",
                                                                                        "keyRaw": "defaultVendor",
                                                                                        "nullable": true,

                                                                                        "selection": {
                                                                                            "fields": {
                                                                                                "id": {
                                                                                                    "type": "UInt",
                                                                                                    "keyRaw": "id",
                                                                                                    "visible": true
                                                                                                },

                                                                                                "code": {
                                                                                                    "type": "String",
                                                                                                    "keyRaw": "code",
                                                                                                    "visible": true
                                                                                                }
                                                                                            }
                                                                                        },

                                                                                        "visible": true
                                                                                    },

                                                                                    "id": {
                                                                                        "type": "UInt",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "lookup": {
                                                                            "type": "String",
                                                                            "keyRaw": "lookup",
                                                                            "visible": true
                                                                        },

                                                                        "price": {
                                                                            "type": "Decimal2",
                                                                            "keyRaw": "price",
                                                                            "visible": true
                                                                        },

                                                                        "quantity": {
                                                                            "type": "Decimal6",
                                                                            "keyRaw": "quantity",
                                                                            "visible": true
                                                                        },

                                                                        "total": {
                                                                            "type": "Decimal2",
                                                                            "keyRaw": "total",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "paid": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "paid",
                                                    "visible": true
                                                },

                                                "purchaseOrderNumber": {
                                                    "type": "String",
                                                    "keyRaw": "purchaseOrderNumber",
                                                    "visible": true
                                                },

                                                "salesperson": {
                                                    "type": "UserAccount",
                                                    "keyRaw": "salesperson",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "Int",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "shippingAddress": {
                                                    "type": "Address",
                                                    "keyRaw": "shippingAddress",

                                                    "selection": {
                                                        "fields": {
                                                            "company": {
                                                                "type": "String",
                                                                "keyRaw": "company",
                                                                "nullable": true,
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "store": {
                                                    "type": "Store",
                                                    "keyRaw": "store",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "subtotal": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "subtotal",
                                                    "visible": true
                                                },

                                                "tax": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "tax",
                                                    "visible": true
                                                },

                                                "total": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "total",
                                                    "visible": true
                                                },

                                                "void": {
                                                    "type": "Boolean",
                                                    "keyRaw": "void",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "pageInfo": {
                                        "type": "PageInfo",
                                        "keyRaw": "pageInfo",

                                        "selection": {
                                            "fields": {
                                                "pageNumber": {
                                                    "type": "Int",
                                                    "keyRaw": "pageNumber",
                                                    "visible": true
                                                },

                                                "pageSize": {
                                                    "type": "Int",
                                                    "keyRaw": "pageSize",
                                                    "visible": true
                                                },

                                                "totalPages": {
                                                    "type": "Int",
                                                    "keyRaw": "totalPages",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "totalItems": {
                                        "type": "Int",
                                        "keyRaw": "totalItems",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "customerId": "UInt",
            "filter": "SalesOrderFilter",
            "pagination": "PaginationOptions",
            "linePagination": "PaginationOptions"
        },

        "types": {
            "Decimal2Filter": {
                "eq": "Decimal2",
                "gt": "Decimal2",
                "gte": "Decimal2",
                "lt": "Decimal2",
                "lte": "Decimal2"
            },

            "CustomerFilter": {
                "active": "Boolean",
                "balance": "Decimal2Filter",
                "companyName": "String",
                "contactName": "String",
                "email": "String",
                "ids": "UInt",
                "keyword": "String",
                "phoneNumber": "String"
            },

            "DateFilter": {
                "eq": "Date",
                "gt": "Date",
                "gte": "Date",
                "lt": "Date",
                "lte": "Date",
                "ne": "Date"
            },

            "SalesOrderDocumentTypeFilter": {
                "affectsInventory": "Boolean",
                "id": "UInt",
                "name": "String"
            },

            "SalesOrderKey": {
                "salesOrderId": "UInt",
                "storeId": "UInt"
            },

            "SalesOrderFilter": {
                "counterpersonUserId": "UInt",
                "customerFilter": "CustomerFilter",
                "date": "DateFilter",
                "documentTypeFilter": "SalesOrderDocumentTypeFilter",
                "finalized": "Boolean",
                "ids": "SalesOrderKey",
                "isSale": "Boolean",
                "storeId": "UInt",
                "void": "Boolean"
            },

            "PaginationOptions": {
                "pageNumber": "Int",
                "pageSize": "Int"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=f01bdb06c1490b3abda406a542a1c39c9ce7cbe67f37aec999b65a69b3ab2054";